import { combineEpicsIsolated } from 'utils/epicRegistry'

import AffMailboxesDetailEpics from './AffMailboxesDetail/epics'
import AtoIncidentEpics from './AtoIncident/epics'
import IncidentsRedesignEpics from './IncidentsRedesign/epics'
import ListEpics from './List/epics'
import MailboxInfoModalEpics from './MailboxInfoModal/epics'
import RemediatedIncidentsEpics from './RemediatedIncidents/epics'
import ReportEpics from './Report/epics'
import ReportCommentsEpics from './ReportComments/epics'
import ReportCommunicationModal from './ReportCommunicationModal/epics'
import ReportedIncidentsEpics from './ReportedIncidents/epics'
import ScanBack from './ScanBack/epics'
import ScannerDetailEpics from './ScannerDetail/epics'
import ServerScanEpics from './ServerScan/epics'
import TagsClassificationEpics from './TagsClassification/epics'

export default combineEpicsIsolated(
  ListEpics,
  ReportEpics,
  AtoIncidentEpics,
  IncidentsRedesignEpics,
  RemediatedIncidentsEpics,
  ReportedIncidentsEpics,
  ServerScanEpics,
  ScannerDetailEpics,
  TagsClassificationEpics,
  AffMailboxesDetailEpics,
  ReportCommentsEpics,
  ReportCommunicationModal,
  ScanBack,
  MailboxInfoModalEpics
)
